import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { FailedSolutions } from './components/FailedSolutions';
import { SolutionReveal } from './components/SolutionReveal';
import { WhatsIncluded } from './components/WhatsIncluded';
import { ForWhom } from './components/ForWhom';
import { Transformation } from './components/Transformation';
import { HowToUse } from './components/HowToUse';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { initPixel, trackPageView } from './utils/pixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen w-full bg-[#FDF8F3] font-sans text-stone-900 selection:bg-amber-200 selection:text-amber-900" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <PainSection data-id="element-3" />
        <FailedSolutions data-id="element-4" />
        <SolutionReveal data-id="element-5" />
        <WhatsIncluded data-id="element-6" />
        <ForWhom data-id="element-7" />
        <Transformation data-id="element-8" />
        <HowToUse data-id="element-9" />
        <CTASection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <FloatingCTA data-id="element-12" />
    </div>;
}